import { useCaptureUtmParams } from '../hooks/useCaptureUtmParams';

export default function UtmCapture(): null {
  useCaptureUtmParams();
  return null;
}
